// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoPagosFullfilledReducer = makeSetReducer(['tipo_pagos/fullfilled']);
